import { useTranslation } from "react-i18next";
import { memo, useCallback } from "react";
// import { createServicePeriod, updateServicePeriodById, getServicePeriodById } from "../../../../../services/servicePeriod.service";
import { TServicePeriodForm, servicePeriodSchema } from "./servicePeriodSchema";
import { FormContainer, Treturn } from "@4uhub/lib4uhub";
import { servicePeriodItems } from "../service-period.mock";
import { ServicePeriodFields } from "./ServicePeriodFields";

interface IServicePeriodProps {
  id?: string;
  onBackButton: () => void;
}

const translationPath = "page.4uDlist.generationRule.servicePeriod.";

export const ServicePeriod = memo(
  ({ id, onBackButton }: IServicePeriodProps) => {
    const { t } = useTranslation();

    //   const { sendRequest: save, loading: sLoading } = useFetch(
    //     createServicePeriod
    //   );

    //   const { sendRequest: update, loading: uLoading } = useFetch(
    //     updateServicePeriodById
    //   );

    //   const { sendRequest: get, loading: gLoading } = useFetch(
    //     getServicePeriodById
    //   );

    const saveHandler = async (v: TServicePeriodForm) => {
      // save({
      //   ...v,
      // });
      return { data: {}, success: true };
    };

    const updateHandler = async (v: TServicePeriodForm, id: string) => {
      // update({
      //   item: {
      //     ...v,
      //   },
      //   id: id,
      // });
      return { data: {}, success: true };
    };

    const getHandler = useCallback(
      async (id: string): Promise<Treturn<TServicePeriodForm>> => {
        //   const { data, success } = await get(id);
        //   if (data && success) {
        //     const newData: TServicePeriodForm = {
        //       ...data,
        //     };
        //     return { data: newData, success: true };
        //   }

        //   return { data, success };

        const data = servicePeriodItems.find((item) => item.id === id);
        if (data) {
          const newData: TServicePeriodForm = {
            ...data,
            startDate: new Date(data.startDate),
            endDate: new Date(data.endDate),
          };
          return { data: newData, success: true };
        }

        return { data: null, success: false };
      },
      [],
    );

    const successHandle = () => {
      onBackButton();
    };

    //   const loading = sLoading || uLoading || gLoading;

    return (
      <FormContainer<TServicePeriodForm>
        saveFunction={saveHandler}
        updateFunction={updateHandler}
        getFunction={getHandler}
        //   loading={loading}
        title={t(translationPath + "service_period")}
        schema={servicePeriodSchema}
        subtitle={t(translationPath + "new_service_period")}
        backButtonOnClick={onBackButton}
        redirectOnSave={false}
        onSuccess={successHandle}
        isModalForm={true}
        propId={id}
        formActionsOnBottom={false}
        fields={() => <ServicePeriodFields />}
      />
    );
  },
);
